<template>
  <el-button type="primary" @click="show = true">操作日志</el-button>

  <el-dialog v-model="show" class="large-dialog" title="操作日志" width="1200">
    <z-dynamic>
      <template #header>
        <el-row :gutter="16">
          <el-col :span="9">
            <el-date-picker
              v-model="time"
              key="date"
              size="medium"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD HH:mm:ss"
              :default-time="[
                new Date(0, 0, 0, 0, 0, 0),
                new Date(0, 0, 0, 23, 59, 59),
              ]"
            />
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="searchParams.eventName"
              placeholder="请输入操作事件"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="searchParams.title"
              placeholder="请输入操作对象名称"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="searchParams.operName"
              placeholder="请输入操作人"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row class="log-search">
          <div>
            <v-select
              v-if="loginUserType === 0"
              v-model:list="searchParams.merchantId"
              message="全部企业"
              url="/shopping-backend/api/merchant/list"
              value="id"
              name="company_name"
            />
          </div>
          <div>
            <el-button type="primary" @click="search"> 查询 </el-button>
            <el-button @click="reset"> 重置 </el-button>
          </div>
        </el-row>
      </template>
      <template #content>
        <!--表格-->
        <z-table
          ref="tableRef"
          :url="
            linkNum
              ? `/shopping-backend/api/operateLog/page/${linkNum}`
              : '/shopping-backend/api/operateLog/list'
          "
          method="post"
          :table-fields="logListFields"
          :condition="searchParams"
        >
        </z-table>
      </template>
    </z-dynamic>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ref, getCurrentInstance, computed, onMounted, reactive } from "vue";
import { logListFields } from "@/data/headerData";

const app = getCurrentInstance()?.proxy;
const tableRef = ref();

export interface Props {
  moduleName: string;
  linkNum: number | string; //操作日志接口
}
const props = withDefaults(defineProps<Props>(), {
  moduleName: "",
  linkNum: "",
});

const show = ref(false);
const time = ref([]);
const searchParams: any = reactive({
  merchantId: computed(() => {
    return app?.$app.merchantId || "";
  }),
  startDate: computed(() => {
    return time.value[0] || "";
  }),
  endDate: computed(() => {
    return time.value[1] || "";
  }),
  eventName: null,
  title: null,
  operName: null,
  operatorType: "",
  page: 1,
  limit: 10,
});

const loginUserType = computed(() => {
  console.log(app?.$app.loginUserType,'sdjouiahjsd');

  return app?.$app.loginUserType || 0;
});

onMounted(() => {
  searchParams.module_name = props.moduleName;
});

const search = () => {
  tableRef.value.search();
};

//重置
const reset = () => {
  searchParams.eventName = null;
  searchParams.title = null;
  searchParams.operName = null;
  searchParams.operatorType = null;
  time.value = [];
  searchParams.page = 1;
  searchParams.limit = 10;
  time.value = [];
  tableRef.value.reset();
};
</script>
<style lang="scss" scoped>
.log-search {
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
}
</style>
